export const iconFontAwesomeUsersPeopleCircleUser = (
	<i className="fa-solid fa-circle-user"></i>
);
